import * as THREE from 'three';
import { CARD1Web, ThreeExt } from './CoordUtils.js';
import './MapControls'

CARD1Web.Camera = {};

CARD1Web.Camera = function(initpos, lookAt, sceneManager) {
  this.camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 2000);
  this.camera.position.x = initpos.x;
  this.camera.position.y = initpos.y;
  this.camera.position.z = initpos.z;
  //相机观察的方向看得更远的地方，因此更新lookAt
  this.distanceFactor = 3;
  
  this.target = this.extendLookAtTarget(lookAt);
  this.sceneManager = sceneManager;
  this.mapControls = new ThreeExt.MapControls(this.camera, this.target, document.getElementById('WebGL-output'));
  sceneManager.scene.add(this.camera);

  this.moveEvents = new Array();

  this.uploadInProgress = false;
}

CARD1Web.Camera.prototype = {
  constructor: CARD1Web.Camera,
  move: function(pos, lookAt) {
    this.camera.position.x = pos.x;
    this.camera.position.y = pos.y;
    this.camera.position.z = pos.z;
    this.target = this.extendLookAtTarget(lookAt);
    
    this.mapControls.updateLookAtTarget(this.target);

  },
  get: function(delta) {
   
    return this.camera;
  },
  checkPos(delta){
     //每次render都会触发此函数，因此在这里可以比较camera位置是否发生了变化以触发当发生变化时的事件
    if (this.lastCameraPos != undefined){
      if(!this.lastCameraPos.equals(this.camera.position)){
          this.onCameraPosChanged(delta);
          //检测当前相机位置和上次距离是否超过相机视距的0.2，如果超过了，需要更新当前视野
          if ((!this.uploadInProgress) && this.lastUpdateRoadPos.distanceTo(this.camera.position) > (this.camera.far * 0.5)){
            this.sceneManager.getRoadManager().drawRoadStakeByPos(this.sceneManager.CoordOffset.lat + this.camera.position.x, this.sceneManager.CoordOffset.lon + this.camera.position.z, null, null, false); 
            this.uploadInProgress = true;  
          }
      }
    } 
    else{
      this.lastCameraPos  = new THREE.Vector3();
    }
    this.lastCameraPos.copy(this.camera.position);

  },
  updateTrackballController: function(delta) {
    this.mapControls.update(delta);
  },
  moveToRoadUnit: function(roadUnit) {
    	var start = roadUnit.start;
      var end = roadUnit.end;
      var cameraVec = new THREE.Vector3();
      //相机设置到右道中间
      var startLoc = new THREE.Vector3();
      var endLoc = new THREE.Vector3();
      
      if (start.roadElementParams["totalLaneNum"]){
        startLoc.copy(start.roadElementParams[start.roadElementParams["totalLaneNum"] - 2]);
        endLoc.copy(end.roadElementParams[end.roadElementParams["totalLaneNum"] - 2]);
          
      }
      else{
        startLoc.lerpVectors(start.a1, start.a2, 0.7);
        endLoc.lerpVectors(end.a1, end.a2, 0.7);
      }
      startLoc.y +=2;
      endLoc.y +=2;
      this.move(startLoc, endLoc);
  	   
    	//两点式方程解出,确定观测点和路的中心在一条直线上
     //  let x1 = roadUnit.start.center.x;
     //  let x2 = roadUnit.end.center.x;
     //  let z1 = roadUnit.start.center.z;
     //  let z2 = roadUnit.end.center.z;
     //  let x = (x1 > x2) ? x1 + 30 : x1 - 30;
     //  let z = (z2 - z1)*(x - x1) / (x2 - x1) + z1;

     //  this.move(new THREE.Vector3(x, center.y + 2, z),
  			// new THREE.Vector3(center.x, center.y + 1, center.z));

  },
  setLastUpdateRoadPos : function(){
    this.lastUpdateRoadPos = this.camera.position.clone();
  },

  //计算当前相机和观察点之间距离的distanceFactor倍数以后的向量延长线的坐标
  extendLookAtTarget: function(lookAt){
      var normVector = new THREE.Vector3();
      normVector.subVectors(lookAt, this.camera.position);
      var vectorLength = this.distanceFactor * normVector.length();
      normVector = normVector.normalize();
      normVector.multiplyScalar(vectorLength);
      return new THREE.Vector3(this.camera.position.x + normVector.x, this.camera.position.y + normVector.y, this.camera.position.z + normVector.z);
  },

//相机发生位移触发的事件
  regCameraPosChanged : function(name, callback, args){
    this.moveEvents[name] = callback;
    this.moveEvents[name].args = args;
  },

  hasRegEvent(name){
    return this.moveEvents[name] != undefined;
  },
  onCameraPosChanged: function(delta){
    for (var prop in this.moveEvents){
      this.moveEvents[prop].call(this, delta,  this.moveEvents[prop].args);
    }
  },

  unRegCameraPosChanged : function(name){
    delete this.moveEvents[name];
  }
  

}



// WEBPACK FOOTER //
// ./src/plugins/drawings3D/camera.js